export default "__VITE_PUBLIC_ASSET__ed86d09a__"